export const FORM_FIELD = {
  ATHLETES: {
    name: 'currentAthletes',
    label: 'Current athletes',
    rules: [{ min: 1, max: 10 }],
    serialize: (field, values) => ({
      [field.name]: values[field.name].map(({ id }) => ({ athleteId: id })),
    }),
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const INITIAL_VALUES = {
  [FORM_FIELD.ATHLETES.name]: [],
};
